import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'hour4u-admin-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  isButtonDisabled: boolean;

  constructor(private location: Location) { }

  ngOnInit() {
  }

  goBack(): void {
    this.isButtonDisabled = true;
    this.location.back();

    setTimeout(() => {
      this.isButtonDisabled = false;
    }, 2000);
  }

}
